import styles from './ScommesseFiltersMobileFooter.module.scss';

export type ScommesseFiltersMobileFooterProps = {
  btnLabel: string;
  handleClose: React.Dispatch<React.SetStateAction<boolean>>;
};

export const ScommesseFiltersMobileFooter = ({ btnLabel, handleClose }: ScommesseFiltersMobileFooterProps) => {
  return (
    <div className={styles.container}>
      <button className={styles.button} type="button" onClick={() => handleClose(false)}>
        {btnLabel}
      </button>
    </div>
  );
};
